import { render, staticRenderFns } from "./ElementHistoricalModal.vue?vue&type=template&id=ca024c6a&"
import script from "./ElementHistoricalModal.vue?vue&type=script&lang=ts&"
export * from "./ElementHistoricalModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports